import type { Dictionnaire } from '../type';

export const profil: Dictionnaire['profil'] = {
  erreurs: {
    compteIntrouvable: '找不到该账号',
    membreIntrouvable: '找不到该成员',
    pseudoPris: '该用户名已被占用',
    spotIntrouvable: '找不到该城市',
    bientot: (spot: string) => `${spot} 即将开放，敬请期待！`,
    prive: (spot: string) => `${spot} 仅对其成员开放。`,
  },
  aideErreurs: {
    vide: '告诉我们发生了什么',
  },
  commun: {
    changerPhoto: '更换我的头像',
    mesDestinations: '我的目的地',
    mesPosts: '我的帖子',
    mesEvenements: '我的活动',
    mesAmis: '我的好友',
    mesSignets: '我的收藏',
    voirTout: '查看全部',
    notePar: (note: string, n: number) => `${n} 位参与者评分 ${note}/5`,
    personnaliser: '编辑我的资料',
    bio: '个人简介',
    debloquer: '解除屏蔽',
    membresBloques: '已屏蔽的成员',
    visibilite: '资料可见范围',
    parametres: '设置',
    aide: '帮助与举报',
    ajouterAmis: '添加好友',
    ecrireA: (nom: string) => `给 ${nom} 发消息`,
  },
  compte: {
    photoMiseAJour: '头像已更新。',
    photoRetiree: '头像已移除。',
    photoImpossible: '照片未能保存',
    enregistre: '资料已保存。',
    impossible: '保存失败',
    enregistrer: '保存',
    retirerPhoto: '移除我的头像',
    pseudo: '用户名',
    bioExemple: '用几句话介绍你自己，以及你在这里想找什么…',
    langues: '我会说的语言',
    languesAide: '使用你会说的语言的聚会排在列表前面。',
  },
  masques: {
    titre: '已隐藏和已屏蔽',
    comptesMasques: '已隐藏的账号',
    comptesBloques: '已屏蔽的账号',
    postsMasques: '已隐藏的帖子',
    afficher: '取消隐藏',
    impossible: '暂时无法完成。',
    comptes: {
      personne: '没有隐藏的账号',
      personneAide: '你可以在对方资料页右上角的三个点中隐藏该账号。',
      explication: '你将不再看到他们的帖子和聚会。对方不会知道，你们之间的其他一切都不变。',
      masque: '已隐藏',
    },
    posts: {
      aucun: '没有隐藏的帖子',
      aucunAide: '你在动态中隐藏的帖子会出现在这里。',
    },
  },
  bloques: {
    impossible: '暂时无法解除屏蔽。',
    personne: '没有屏蔽任何人',
    personneAide: '你可以在成员资料页右上角的三个点中屏蔽对方。',
    explication: '你将不再看到对方的帖子和活动，你们的对话也会被隐藏。',
    bloque: '已屏蔽',
  },
  destinations: {
    villes: '城市',
    actuel: '当前服务器',
    changer: '切换服务器',
  },
  amis: {
    aucun: '你还没有好友',
    aucunAide: '服务器推荐和收到的申请正在等你。',
    trouver: '寻找成员',
  },
  aide: {
    impossible: '暂时无法发送。',
    envoyer: '发送',
    intro: '告诉我们发生了什么。我们的团队会阅读每一条，并通过邮件回复。',
    sujet: '是关于什么的？',
    raconte: '说说情况',
    raconteExemple: '发生了什么、在哪里，如有需要请说明涉及的人。',
    sujets: {
      member: '某位成员',
      event: '某个活动',
      content: '某条帖子或消息',
      bug: '技术问题',
      other: '其他',
    },
  },
  membre: {
    ami: {
      none: '加为好友',
      requested: '申请已发送',
      incoming: '接受申请',
      friends: '删除好友',
    },
    ceMembre: '这位成员',
    profil: '资料',
    refuserQ: '拒绝对方的好友申请？',
    refuser: '拒绝好友申请',
    debloquerMembre: '解除屏蔽这位成员',
    bloquerMembre: '屏蔽这位成员',
    masquerCompte: '隐藏这个账号',
    nePlusMasquer: '取消隐藏这个账号',
    estMasque: (nom: string) => `已隐藏 ${nom}。你将不再看到对方的帖子和活动。`,
    plusMasque: (nom: string) => `已取消隐藏 ${nom}。`,
    ecrire: '发消息',
    tuAsBloque: '你已屏蔽这位成员',
    tuAsBloqueAide: '对方的帖子不会再出现在你的动态中，也不会再被推荐给你。',
    officiel: '这是 Sirocco 团队的账号。有任何问题都可以给它发消息。',
    reserve: '资料仅对好友可见',
    reserveAide: '发送好友申请即可查看对方的帖子。',
    sesDestinations: 'TA 的目的地',
    sesEvenementsMasques: 'TA 的设置隐藏了活动。',
    demandeRefusee: (nom: string) => `已拒绝 ${nom} 的申请。`,
    debloque: (nom: string) => `已解除对 ${nom} 的屏蔽。`,
    bloquerQ: (nom: string) => `屏蔽 ${nom}？`,
    bloque: (nom: string) => `已屏蔽 ${nom}。对方将无法再给你发消息或发送好友申请。`,
    retirerAmiQ: (nom: string) => `把 ${nom} 从好友中删除？`,
    plusAmi: (nom: string) => `${nom} 已不再是你的好友。`,
    appeler: (nom: string) => `给 ${nom} 打电话`,
    avis: (n: string) => `· ${n} 条评价`,
  },
  notifications: {
    choix: {
      messages: '消息',
      appels: '通话',
      amis: '好友申请',
      postsAmis: '好友的帖子',
      evenements: '活动',
      acceptee: '报名已通过',
      inscriptions: '我的活动的报名',
      desinscriptions: '我的活动的退出',
      reactions: '对我帖子的回应',
      mentions: '提及',
    },
    titre: '通知',
  },
  motDePasse: {
    troisConditions: '这个密码不符合三项要求',
    pasIdentiques: '两次输入的密码不一致',
    impossible: '修改失败',
    titre: '邮箱与密码',
    changer: '修改我的密码',
    actuel: '当前密码',
    nouveau: '新密码',
    confirmer: '确认新密码',
    envoye: '邮件已发送',
    lienRecu: (email: string) => `打开发送到 ${email} 的链接，设置新密码。`,
  },
  ecran: {
    modifier: '编辑我的资料',
    mesEvenementsSorties: '我的活动与聚会',
  },
  visibilite: {
    intro: '选择服务器的其他成员打开你的资料时能看到什么。',
    quiPeutVoir: '谁能看到我的资料',
    toutLeServeur: '整个服务器',
    amisSeulement: '仅限好友',
    ceQuiApparait: '我的资料上显示什么',
    evenementsAide: '其他人可以看到我参加了什么',
    mesDestinationsAide: '我去过的城市',
    postsAide: '可在我的资料中查看',
    enLigne: '在线状态',
    enLigneAide: '头像上的绿点',
    destinationsAmis: '我的目的地仅对好友可见',
    destinationsAide: '我去过的城市，仅好友可见',
    messages: '消息',
  },
  tableau: {
    mois: '最近 30 天',
    posts: '帖子',
    tenues: '已举办活动',
    presences: '签到',
    inscriptions: '每周注册',
    cetteSemaine: '本周',
    ilYaSemaines: (n: number) => `${n} 周前`,
    nInscriptions: (n: number) => `${n} 次注册`,
    fidelite: '留存',
    revenus: '第一周后仍会回来',
    encoreActifs: '一个月后仍然活跃',
    surN: (n: number, sur: number) => `${sur} 人中的 ${n} 人`,
    pasAssez: '时间还不够长',
    parServeur: '按服务器',
    serveurLigne: (membres: number, actifs: number) => `${membres} 名成员 · 本周 ${actifs} 人活跃`,
    serveurDetail: (posts: number, tenues: number, presences: number, aVenir: number) =>
      `${posts} 条帖子（7 天）· ${tenues} 场活动、${presences} 次签到（30 天）· ${aVenir} 场即将举行`,
    sansServeur: '无服务器',
    titre: '数据面板',
    actifsAujourdhui: '今日活跃',
    semaine: '本周',
    comptes: '账号',
    nouveaux: '新增（7 天）',
    unSignalement: '1 条举报待处理',
    connexions: '最近登录',
    versions: '已安装的版本',
    unCompte: '1 个账号',
    sorties: '即将开始的聚会',
    rien: '暂无安排。',
    spontanee: '临时',
    jamais: '从未',
    depuis: {
      minutes: (n: number) => `${n} 分钟前`,
      heures: (n: number) => `${n} 小时前`,
      jours: (n: number) => `${n} 天前`,
    },
    build: (n: string) => ` · 构建 ${n}`,
    signalements: (n: number) => `${n} 条举报待处理`,
    nComptes: (n: number) => `${n} 个账号`,
  },
  reglages: {
    apparences: {
      system: '自动',
      day: '浅色',
      night: '深色',
    },
    apparenceAide: {
      system: '跟随手机设置。',
      day: '始终浅色，不受手机影响。',
      night: '始终深色，不论几点。',
    },
    deconnexionImpossible: '退出失败。请重试。',
    suppressionImpossible: '删除失败',
    compte: '账号',
    emailEtMotDePasse: '邮箱地址与密码',
    serveur: '服务器 / 目的地',
    confidentialite: '隐私',
    coupees: '已在手机设置中关闭',
    moderation: '内容审核',
    tableau: '数据面板',
    administration: '管理',
    application: '应用',
    apparence: '外观',
    langue: '语言',
    deconnecterQ: '退出登录？',
    deconnecter: '退出登录',
    supprimerQ: '永久删除你的账号？你的帖子和消息都将被删除。',
    supprimer: '删除我的账号',
  },
};
